import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderFormComponent } from './order-form.component';
import { MatStepperModule } from '@angular/material/stepper';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_LOCALE_FACTORY, MatOptionModule, DateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { TicketCardModule } from '../../ticket-card/ticket-card.module';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ImageModule } from '../../image/image.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackbarMessageModule } from '../../snackbar-message/snackbar-message.module';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OrderCardInfoModule } from '../../order-card-info/order-card-info.module';
import { MatRadioModule } from '@angular/material/radio';
import { TicketTypeComponent } from '../../ticket-type/ticket-type.component';
import { MatDividerModule } from '@angular/material/divider';
import { OrderCardInfoTicketModule } from "../../order-card-info-ticket/order-card-info-ticket.module";
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CustomDateAdapter } from 'src/app/util/custom-date-apter.util';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [
    OrderFormComponent,
    TicketTypeComponent
  ],
  imports: [
    CommonModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatIconModule,
    TranslateModule,
    MatFormFieldModule,
    MatOptionModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatSnackBarModule,
    SnackbarMessageModule,
    MatRadioModule,
    ImageModule,
    MatProgressBarModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatButtonModule,
    MatTableModule,
    TicketCardModule,
    OrderCardInfoModule,
    MatDividerModule,
    OrderCardInfoTicketModule,
    NgxMatSelectSearchModule,
    MatExpansionModule 

],
  exports: [
    OrderFormComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en' }, 
    { provide: DateAdapter, useClass: CustomDateAdapter },
    // Platform
  ]
})
export class OrderFormModule { }
